import BaseDrawingService from './BaseDrawingService';

class GrowthRateDrawingService extends BaseDrawingService {
    parseData(data) {
        const parsedData = {};

        Object.keys(data).forEach((dataKey) => {
            const splitRevenues = [[]];
            let currentRevenuesIndex = 0;

            data[dataKey].forEach((revenue) => {

                if (typeof revenue.drugBrandIds !== 'undefined' && revenue.drugBrandIds.length > 0) {
                    splitRevenues[currentRevenuesIndex].push(revenue);
                } else {
                    splitRevenues.push([]);
                    currentRevenuesIndex += 1;
                }
            });

            parsedData[dataKey] = splitRevenues;
        });

        return parsedData;
    }

    lineClickEvent(id) {
        super.lineClickEvent(id, 'growth', 'name');
    }
}

export default GrowthRateDrawingService;
